import React from 'react'
import clsx from 'clsx'
import { Link, useHistory, useLocation } from 'react-router-dom'

import { Button, Icon, SocialMediaIcons } from '../'

import './HomeLayout.scss'
import { isDesktop } from '../../utils'
import { useDispatch, useSelector } from 'react-redux'
import { toggle } from '../../store/theme'

const HomeLayout = ({ children }) => {
   const { pathname } = useLocation()
   const history = useHistory()
   const dispatch = useDispatch()
   const { isDarkTheme } = useSelector(state => state.theme)

   if (isDesktop()) {
      return (
         <div
            className={clsx(
               'DesktopHomeLayout',
               isDarkTheme && 'DesktopHomeLayout--dark'
            )}
         >
            <nav className="DesktopHomeLayout__nav">
               <h1 className="DesktopHomeLayout__nav-brand">WallStreetNinja</h1>
               <div className="DesktopHomeLayout__nav-list">
                  <Link
                     className="DesktopHomeLayout__nav-list-item"
                     to="/register"
                  >
                     Create Account
                  </Link>
                  <Link
                     className="DesktopHomeLayout__nav-list-item"
                     to="/restore-account"
                  >
                     Restore or Import
                  </Link>
               </div>
               <Icon
                  className="DesktopHomeLayout__nav-icon"
                  name={isDarkTheme ? 'moon' : 'sun'}
                  onClick={() => dispatch(toggle())}
                  size={24}
               />
            </nav>
            <main className="DesktopHomeLayout__main">{children}</main>
            <footer className="DesktopHomeLayout__footer">
               <SocialMediaIcons className="DesktopHomeLayout__footer-social-icons" />
               <Button isDarkTheme={isDarkTheme} size="lg">
                  English
               </Button>
            </footer>
         </div>
      )
   }

   return (
      <div className={clsx('HomeLayout', isDarkTheme && 'HomeLayout--dark')}>
         {pathname !== '/login' && (
            <div
               className={clsx(
                  'HomeLayout__top-bar',
                  pathname === '/' && 'HomeLayout__top-bar--end'
               )}
            >
               {pathname !== '/' && (
                  <Icon
                     className="HomeLayout__back-icon"
                     name="chevron-left"
                     onClick={() => history.goBack()}
                  />
               )}
               <Button isDarkTheme={isDarkTheme}>English</Button>
            </div>
         )}
         {children}
         <footer className="HomeLayout__footer">
            <SocialMediaIcons className="HomeLayout__footer-social-icons" />
         </footer>
      </div>
   )
}

export default HomeLayout
